import { render, staticRenderFns } from "./warehouseWarrantDetail.vue?vue&type=template&id=2fffed80&scoped=true&"
import script from "./warehouseWarrantDetail.vue?vue&type=script&lang=js&"
export * from "./warehouseWarrantDetail.vue?vue&type=script&lang=js&"
import style0 from "./warehouseWarrantDetail.vue?vue&type=style&index=0&id=2fffed80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffed80",
  null
  
)

export default component.exports